<template>
    <v-card>
     <v-card-title>
       <v-icon x-large>mdi-account</v-icon>
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="users"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900px">
          <!--<template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                     <v-col cols="12" sm="6" md="12">
                      <v-text-field :disabled="true" v-model="editedItem.ApiUser_id"
                        label="Usuario ID"  :counter="30" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.ApiUser_GivenName" :rules="givenRules" label="Nombre Completo"
                        :counter="61" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.ApiUser_EMail"
                        :rules="emailRules"
                        label="E-mail"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_pass" max-width="900px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn color="accent" text @click="save_pwd">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">NUEVO USUARIO</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                     <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiUser_id" :rules="idRules" label="Usuario ID"
                        :counter="30" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.ApiUser_GivenName" :rules="givenRules" label="Nombre Completo"
                        :counter="61" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.ApiUser_EMail"
                        :rules="emailRules"
                        label="E-mail"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    search: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    valid: true,
    headers: [
      { text: 'Usuario ID', value: 'ApiUser_id' },
      { text: 'Nombre Completo', value: 'ApiUser_GivenName' },
      { text: 'EMail', value: 'ApiUser_EMail' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    users: [],
    editedIndex: -1,
    editedItem: {
      ApiUser_GivenName: '',
      ApiUser_EMail: '',
      ApiUserType_id: 'R'
    },
    defaultItem: {
      ApiUser_GivenName: '',
      ApiUser_EMail: '',
      ApiUserType_id: 'R'
    },
    idRules: [
      v => !!v || 'Usuario ID es requerido',
      v => (v && v.length <= 30) || 'Usuario ID debe tener menos de 30 caracteres'
    ],
    emailRules: [
      v => !!v || 'E-mail es requerido',
      v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido'
    ],
    givenRules: [
      v => !!v || 'Nombre Completo es requerido',
      v => (v && v.length <= 61) || 'Nombre Completo debe tener menos de 30 caracteres'
    ],
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      axios.post(this.api_tool_url + '/get_users', {}, this.config)
        .then(response => {
          this.users = response.data.ResultRows
        })
        .catch(error => {
          this.users = []
          alert(error.response.data.message)
        })
    },

    newtItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_new = true
    },

    editItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.users.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.deleteUser(index)
    },

    deleteUser (index) {
      let userTmp = this.users[index]
      delete userTmp.ApiUser_GivenName
      delete userTmp.ApiUser_Name
      delete userTmp.ApiUser_LastName
      delete userTmp.ApiUser_EMail
      delete userTmp.ApiUser_Password
      delete userTmp.ApiEnableUser_Ind
      axios.post(this.api_tool_url + '/del_user', userTmp, this.config)
        .then(response => {
          this.users.splice(index, 1)
          this.close()
        })
        .catch(error => {
          this.users = []
          alert(error.response.data.message)
        })
    },

    close () {
      this.dialog = false
      this.dialog_pass = false
      this.dialog_new = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        axios.post(this.api_tool_url + '/upd_user', this.editedItem, this.config)
          .then(response => {
            Object.assign(this.users[this.editedIndex], response.data.ResultRows[0])
            this.close()
          })
          .catch(error => {
            this.users = []
            alert(error.response.data.message)
          })
        // Object.assign(this.users[this.editedIndex], this.editedItem)
      } else {
        axios.post(this.api_tool_url + '/ins_user', this.editedItem, this.config)
          .then(response => {
            // console.log(response)
            this.users.push(response.data.ResultRows[0])
            this.close()
          })
          .catch(error => {
            this.users = []
            alert(error.response.data.message)
          })
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserGrid.vue